
/**
 * CONTINAS CONTANTS ROUTES
 */

const ROUTES = {
  /**
   * General
   */
  DEFAULT: '/sports',
  HOME: '/sports',
  REGISTER: '/sports/register',
  LOGOUT: '/sports/logout',
  LOGIN: '/sports/login',
  PRIVACY_POLICY: '/privacy-policy',
  HELP: '/help',
  CONTACT: '/contact-us',
  LOCK: '/sports/lock',
  ERROR: '/error',

  /**
   * Pages
   */
  SPORTS: '/sports',
  UPCOMING: '/sports/upcoming',
  FOOTBALL: '/sports/football',
  BASEBALL: '/sports/baseball',
  BASKETBALL: '/sports/basketball',
  NBA: '/sports/nba',
  PROMOTIONS: '/sports/promotions',

  /**
   * Player
   */
  PLAYER: {
    MYBETS: '/sports/player/mybets',
    PROFILE: '/sports/player/profile',
    TICKET: {
      DETAIL: '/sports/player/ticket/:ticket_id',
    }
  },

  /**
   * Shop
   */
  SHOP: {
    TICKET: {
      LIST: '/sports/shop/tickets',
      DETAIL: '/sports/shop/ticket/:ticket_id',
    }
  },

  /**
   * Event route pattern (to be appended to sport routes)
   */
  EVENT: '/:league_slug/:event_description_slug/:event_id',
};

export default ROUTES;
